import React from "react";
import { PROCESS } from "../data/site";
import { Reveal, SectionHeading } from "./Reveal";

export const Process = () => (
  <section id="process" className="mx-auto max-w-7xl px-5 md:px-8 py-24 md:py-32">
    <Reveal>
      <SectionHeading
        overline="Our Process"
        title="Five Steps to New Branding"
        sub="A clear, no-surprises path from your first enquiry to a freshly branded fleet."
      />
    </Reveal>
    <div className="mt-14 grid md:grid-cols-5 gap-px bg-line border border-line">
      {PROCESS.map((p, i) => (
        <Reveal key={p.n} delay={i * 0.08}>
          <div data-testid={`process-${i}`} className="group h-full bg-ink-900 p-7 hover:bg-ink-800 transition-colors relative">
            <span className="font-head font-black text-5xl text-white/10 group-hover:text-orange/30 transition-colors">{p.n}</span>
            <div className="mt-3 h-1 w-8 bg-orange" />
            <h3 className="mt-4 font-head font-extrabold uppercase text-base tracking-tight">{p.title}</h3>
            <p className="mt-2 text-white/55 text-sm leading-relaxed">{p.desc}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
